import { parseContextFromPathname } from "./os-href";

/** Share cached queries within a workspace, never across principal or management context. */
export function apiWorkspaceScopeKey(pathname: string): string {
  const { contextParam, teamSlug, memberHandle } =
    parseContextFromPathname(pathname);
  return contextParam
    ? JSON.stringify([contextParam, teamSlug, memberHandle])
    : "account";
}
